// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WhatsappMessageTemplates_RemoverWhatsappMessageTemplateInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/whatsapp_message_templates/remover_whatsapp_message_template/{template_id}
 *
 * Removes a WhatsApp message template. No body required — template_id is a URL path parameter.
 */
import { registerContract } from './validate'

export interface WhatsappMessageTemplates_RemoverWhatsappMessageTemplateInput {}

registerContract('WhatsappMessageTemplates_RemoverWhatsappMessageTemplateInput', {})
